import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonButton
} from '@ionic/react';
import { Link, Redirect } from 'react-router-dom';
import { Formik, Form } from 'formik';
import alerts from 'src/lib/alerts';
import Field from 'src/components/Field';
import Subscribe from 'src/components/Subscribe';
import yup from 'src/feathers/yup';
import app from 'src/feathers';

class Login extends React.Component {
  schema = yup.object({
    email: yup.trimmedString().required().email().label('Email'),
    password: yup.trimmedString().required().label('Password')
  });

  handleSubmit = (data, formik) => {
    app
      .authenticate({
        strategy: 'local',
        ...data
      })
      .then((authData) => {
        formik.setSubmitting(false);
        const { location, history } = this.props;
        if (location.query && location.query.redirect) {
          history.push(location.query.redirect);
        } else {
          history.push('/');
        }
      })
      .catch((err) => {
        formik.setSubmitting(false);
        alerts.errors(err.message);
        if (err.errors) {
          formik.setErrors(err.errors);
        }
      });
  };

  render() {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Murphy</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonGrid fixed style={{ paddingTop: 100 }}>
            <IonRow>
              <IonCol sizeLg="4" offsetLg="4">
                <IonCard>
                  <IonCardHeader>
                    <IonCardSubtitle>Login</IonCardSubtitle>
                    <IonCardTitle>Welcome Back!</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent>
                    <Formik
                      initialValues={{ email: '', password: '' }}
                      onSubmit={this.handleSubmit}
                      validationSchema={this.schema}
                      render={({ isSubmitting }) => {
                        return (
                          <Form>
                            <Field
                              type="email"
                              name="email"
                              label="Email"
                              disabled={isSubmitting}
                            />
                            <Field
                              type="password"
                              name="password"
                              label="Password"
                              disabled={isSubmitting}
                            />
                            <IonButton
                              type="submit"
                              color="primary"
                              expand="block"
                              className="ion-margin-bottom"
                              disabled={isSubmitting}
                            >
                              Login
                            </IonButton>
                            <Link to="/forgot-password" disabled={isSubmitting}>
                              Forgot Password
                            </Link>
                          </Form>
                        );
                      }}
                    />
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonPage>
    );
  }
}

export default (props) => {
  return (
    <Subscribe
      render={(container) => {
        if (container.state.authenticated) {
          return <Redirect to="/" />;
        }
        return <Login {...props} />;
      }}
    />
  );
};
